import { Inbox, MessagesSquare } from 'lucide-react';
import { TabbedPage } from '../components/common/TabbedPage';

/** Conversations and the website's enquiries: everything people sent the office. */
export const COMMUNICATION_TABS = [
  { path: '/communications', label: 'Conversations', icon: <MessagesSquare size={16} /> },
  { path: '/communications/inquiries', label: 'Inquiries', icon: <Inbox size={16} /> },
];

export function CommunicationHubPage() {
  return (
    <TabbedPage
      title="Communication"
      icon={<MessagesSquare size={24} className="text-primary-600" />}
      tabs={COMMUNICATION_TABS}
    />
  );
}
